import { DTOWorkspaceRole, DTOWorkspaceSeatType } from "./enums";
import { z } from "zod";
export const DTOWorkspaceInvitation = z.object({
    id: z.string(),
    email: z.string().email(),
    createdAt: z.coerce.date(),
    resentAt: z.coerce.date().nullish(),
    role: DTOWorkspaceRole,
    seatType: DTOWorkspaceSeatType,
    workspaceId: z.string(),
    invitedBy: z.string(),
    effectiveRole: DTOWorkspaceRole,
    effectiveSeatType: DTOWorkspaceSeatType,
});
export const DTOWorkspaceInvitationInput = z.object({
    email: z.string().email(),
    role: DTOWorkspaceRole,
    seatType: DTOWorkspaceSeatType.optional(),
    isDeveloperInvite: z.boolean().optional(),
});
export const DTOWorkspaceInvitationsListInput = z.object({
    invites: DTOWorkspaceInvitationInput.array().max(100),
    designSystemId: z.string().optional(),
});
export const DTOWorkspaceInvitationsResponse = z.object({
    invitations: DTOWorkspaceInvitation.array(),
});
export const DTOWorkspaceInviteUpdate = z.object({
    role: DTOWorkspaceRole,
    seatType: DTOWorkspaceSeatType.optional(),
});
export const DTOWorkspaceInvitationUpdateResponse = z.object({
    invitation: DTOWorkspaceInvitation,
});
